<template>
    <div class="wrapper">
        <div class="menuWrapper" v-if="shopDealsMetadata">
            <ordersMenu 
                ref="ordersMenuComp"
                @changeActiveTab="changeActiveTab"
            />
        </div>
        <div class="mainBody">
            <div style="overflow: hidden; box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.15); border-radius: 20px; margin-top: 20px;" v-if="activeTab == 'ordersTable'">
                <ordersTable
                    ref="ordersTableRef"
                    :shopOrders="shopDeals"
                    :statusData="statusData"
                    :shopDealsMetadata="shopDealsMetadata"
                    :mainInvoice="mainInvoice"
                    @changeStatusGroup="changeStatusGroup"
                    @getOrderContent="getOrder"
                    @getInvoices="getInvoices"
                    @acceptDeals="acceptDeals"
                    @refuseDeals="refuseDeals"
                    @markDealsShipped="markOrdersShipped"
                    @finalizeDeals="finalizeDeals"
                    @downloadInvoice="downloadInvoice"
                />
            </div>
            <div class="singleTab" v-if="activeTab == 'orders'">
                <singleOrderCard 
                    v-for="(element, index) in shopDeals" :key="index"
                    :dealData='element'
                    :idShop='idShop'
                    :index='index'
                    :activeStatus='activeStatus'
                    :statusData="statusData"
                    ref="singleOrderCard"
                />
            </div>
            <div class="singleTab" v-if="activeTab == 'transactions'">
                <transactions 
                    :transactions="transactions"
                    :wallet="wallet"
                />
            </div>
        </div>
    </div>
</template>
  
<script>
import statusDataJS from '@kristjan87/storium-workboard-library/src/components/main/orders/singleOrder/status';
import ordersMenu from '@kristjan87/storium-workboard-library/src/components/main/orders/menu/menu.vue';
import ordersTable from '@kristjan87/storium-workboard-library/src/components/main/orders/table/table.vue';

import singleOrderCard from '@kristjan87/storium-workboard-library/src/components/main/orders/singleOrder/card/card.vue';
import transactions from '@kristjan87/storium-workboard-library/src/components/main/orders/transactions/transactions.vue';


import core from '../api/index'

// import core from '../api/index'
export default {
    name: 'ordersView',
    components: {
        ordersMenu,
        ordersTable,
        singleOrderCard,
        transactions
    },
    props: {
        idShop: null,
        shopData: null,
    },
    watch: {
        shopDeals: {
            handler(newVal) {
                if (newVal) {
                    // this.getShopDealsMetadata()
                }
            },
            immediate: true, // Executes the watcher immediately on component creation
            deep: true // Watches the nested properties if needed
        }
    },
    data() {
        return {
            activeTab: 'ordersTable',
            shopDealsMetadata: null,
            shopDeals: [],
            render: false,
            activeStatus: null,
            statusData: null,
            mainInvoice: null,

            wallet: null,
            transactions: null,
        };
    },
    computed: {
      
    },
    methods: {
        changeActiveTab(newTab) {
            this.activeTab = newTab
        },
        returnStatusData(activeStatus, statusData) {
            this.activeStatus = activeStatus
            this.statusData = statusData
        },

        getShopDealsMetadata() {
            core.dealApi.getShopDeals({
                pathParam: this.idShop,
                queryParams: {
                    metadata: true
                }
            })
            .then(res => {
                if(res.data.deals) {
                    this.shopDealsMetadata = res.data.deals.metadata
                }
            })
        },

        changeStatusGroup(group) {
            this.getShopDeals(group.code)
        },

        getInvoices(idDeal) {
            fetch(this.$fetchIp+'/v2/deal/invoices/'+idDeal, {
                method: 'GET',
                headers: {
                    'Content-type':'application/json',
                    'Authorization': 'salaTokken'
                },
                credentials: 'include',
            })
            .then((res) => res.json())
            .then((res) => {
                const invoices = res.data.invoices

                // this.extraPaymentsInvoices = []
                invoices.forEach(invoice => {
                    // if(invoice.invoiceType == 'extra') {
                    //     this.extraPaymentsInvoices.push(invoice)
                    // }
                    if(invoice.invoiceType == 'debit') {
                        this.mainInvoice = invoice
                    }
                    // if(invoice.invoiceType == 'credit') {
                    //     this.disputeInvoice = invoice
                    // }
                    // if(invoice.invoiceType == 'partialCredit') {
                    //     this.disputeInvoice = invoice
                    // }
                })
                
            })
        },

        downloadInvoice(idDeal) {
            fetch(this.$fetchIp+'/v2/'+'deal/'+idDeal+'/invoice/'+this.mainInvoice.idInvoice+'/pdf', {
                headers: {
                    'Content-type':'application/json',
                    'Authorization': 'salaTokken'
                },
                method: 'GET',
                credentials: 'include',
            })
            .then((res) => res.blob())
            .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${this.mainInvoice.reference}.pdf`);
                document.body.appendChild(link);
                link.click();
            })
        },

        async getShopDeals(activeStatusGroup) {
            this.getShopDealsMetadata()
            let statusQueries = [];

            // Determine the statuses to query based on activeStatusGroup
            if (activeStatusGroup === 'inProcess') {
                statusQueries = ['isNotAccepted=true', 'isNotShipped=true'];
            }
            if (activeStatusGroup === 'inTransit') {
                statusQueries = ['isDelivered=true', 'isShipped=true'];
            }
            if (activeStatusGroup === 'isFinalized') {
                statusQueries = ['isFinalized=true', 'isCancelled=true'];
            }
            if (activeStatusGroup === 'inReturn') {
                statusQueries = ['isDisputed=true'];
            }

            try {
                let allDeals = [];

                for (let query of statusQueries) {
                    const response = await fetch(`${this.$fetchIp}/v2/deal/shop/${this.idShop}?offset=0&limiter=100&${query}`, {
                        method: 'GET',
                        headers: {
                            'Content-type': 'application/json',
                            'Authorization': 'salaTokken'
                        },
                        credentials: 'include',
                    });

                    const res = await response.json();
                    
                    if (res.status === 'success' && res.data.deals) {
                        allDeals = allDeals.concat(res.data.deals);
                    }
                }

                // Remove duplicates if any (in case a deal matches both statuses)
                const uniqueDeals = allDeals.reduce((acc, current) => {
                    const x = acc.find(item => item.idDeal === current.idDeal);
                    if (!x) {
                        return acc.concat([current]);
                    } else {
                        return acc;
                    }
                }, []);

                // Assign the deals to shopDeals and set dealStatus
                this.shopDeals = uniqueDeals.map(order => ({
                    ...order,
                    dealStatus: this.getDealStatus(order)
                }));
            } catch (error) {
                console.error('Failed to fetch deals:', error);
                this.shopDeals = [];
            }
        },

        getShopTransactions() {
            core.walletApi.getShopWallet({
                pathParam: this.idShop
            })
            .then(res => {
                if(res.data) {
                    const { wallet } = res.data
                    this.wallet = wallet
                    core.walletApi.getWalletTransactions({
                        pathParam: wallet.address
                    })
                    .then(res => {
                        if(res.data.transactions != null) {
                            this.transactions = res.data.transactions
                        }
                        
                    })
                }
            })
        },

        getOrder(idDeal, idOrder) {
            fetch(this.$fetchIp+'/v2/order/'+idOrder, {
                method: 'GET',
                headers: {
                    'Content-type':'application/json',
                    'Authorization': 'salaTokken'
                },
                credentials: 'include',
            })
            .then((res) => res.json())
            .then((res) => {
                const listings = res.data.order.listings;
                const order = this.shopDeals.find(order => order.idDeal === idDeal);
                if (order) {
                    order.orderContent = listings;
                }

                let idShippingInstructions = res.data.order.idShippingInstructions
                this.getShippingInstructions(idDeal, idShippingInstructions)
            })
        },

        getShippingInstructions(idDeal, idShippingInstructions) {
            fetch(this.$fetchIp+'/v2/shipping/instructions/'+idShippingInstructions, {
                method: 'GET',
                headers: {
                    'Content-type':'application/json',
                    'Authorization': 'salaTokken'
                },
                credentials: 'include',
            })
            .then((res) => res.json())
            .then((res) => {
                if(res.data.shippingInstructions) {
                    const shippingOption = res.data.shippingInstructions.shippingOption;
                    
                    let shippingOptionET

                    if(shippingOption == 'parcelTerminal') {
                        shippingOptionET = 'Pakiautomaat'
                    }
                    if(shippingOption == 'merchantDelivery') {
                        shippingOptionET = 'Kaupleja tarne'
                    }
                    if(shippingOption == 'pickupMethod') {
                        shippingOptionET = 'Pakikorje'
                    }
                    if(shippingOption == 'arrangementMethod') {
                        shippingOptionET = 'Kokkuleppeline'
                    }
                    if(shippingOption == 'courierDelivery') {
                        shippingOptionET = 'Pakikuller'
                    }

                    const order = this.shopDeals.find(order => order.idDeal === idDeal);
                    if (order) {
                        order.shippingInstructions = {method: shippingOptionET, instructions: res.data.shippingInstructions};
                    }
                }
            })
        },

        getDealStatus(deal) {
            if (!deal) return { status: 'No active deal', severity: 'default' };

            if (deal.isRejected) return { status: 'Tagasi lükatud', severity: 'secondary', icon: 'pi pi-times' };
            if (deal.isCancelled) return { status: 'Tühistatud', severity: 'secondary', icon: 'pi pi-ban' };
            if (deal.isDisputed) return { status: 'Tagastamisel', severity: 'warn', icon: 'pi pi-thumbs-down' };
            if (deal.isFinalized) return { status: 'Lõpetatud', severity: 'success', icon: 'pi pi-check' };
            if (deal.isDelivered) return { status: 'Kohale toimetatud', severity: 'success', icon: 'pi pi-verified' };
            if (deal.isShipped) return { status: 'Saadetud', severity: 'info', icon: 'pi pi-send' };
            if (deal.isPaid && deal.isAccepted) return { status: 'Töösse võetud', severity: 'info', icon: 'pi pi-hourglass' };
            if (deal.isPaid) return { status: 'Makstud', severity: 'contrast', icon: 'pi pi-euro' };

            return { status: 'Unknown status', severity: 'default' };
        },

        async acceptDeals(selectedOrders) {
            const acceptOrders = async () => {
                try {
                    const promises = selectedOrders.map(element => 
                        fetch(this.$fetchIp + '/v2/deal/accept/' + element.idDeal, {
                            method: 'PATCH',
                            headers: {
                                'Content-type': 'application/json',
                                'Authorization': 'salaTokken'
                            },
                            credentials: 'include',
                        })
                        .then(res => res.json())
                    );

                    const results = await Promise.all(promises);

                    const allSuccessful = results.every(res => res.status === 'success');

                    if (allSuccessful) {
                        this.getShopDeals('inProcess')
                        this.$toast.add({ severity: 'info', summary: 'Kinnitatud', detail: `${selectedOrders.length} tellimust vastu võetud`, life: 5000 });
                        this.$refs.ordersTableRef.selectedOrders = []
                    } else {
                        console.error('Some deals were not accepted successfully.');
                    }
                } catch (error) {
                    console.error('An error occurred while accepting deals:', error);
                }
            };

            this.$confirm.require({
                message: `Oled kindel, et soovid ${selectedOrders.length} tellimust vastu võtta?`,
                header: 'Kinnitus',
                icon: 'pi pi-exclamation-triangle',
                rejectProps: {
                    label: 'Tühista',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Kinnita'
                },
                accept: acceptOrders
            });
        },
        
        async refuseDeals(selectedOrders) {
            const refuseOrders = async () => {
                try {
                    const promises = selectedOrders.map(element => 
                        fetch(this.$fetchIp + '/v2/deal/reject/' + element.idDeal, {
                            method: 'PATCH',
                            headers: {
                                'Content-type': 'application/json',
                                'Authorization': 'salaTokken'
                            },
                            credentials: 'include',
                        })
                        .then(res => res.json())
                    );

                    const results = await Promise.all(promises);

                    const allSuccessful = results.every(res => res.status === 'success');

                    if (allSuccessful) {
                        this.getShopDeals('inProcess')
                        this.$toast.add({ severity: 'warn', summary: 'Tagasi lükatud', detail: `${selectedOrders.length} tellimust tagasi lükatud`, life: 5000 });
                        this.$refs.ordersTableRef.selectedOrders = []
                    } else {
                        console.error('Some deals were not refused successfully.');
                    }
                } catch (error) {
                    console.error('An error occurred while refusing deals:', error);
                }
            };

            this.$confirm.require({
                message: `Oled kindel, et soovid ${selectedOrders.length} tellimust TAGASI LÜKATA?`,
                header: 'Kinnitus',
                icon: 'pi pi-exclamation-triangle',
                rejectProps: {
                    label: 'Tühista',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Kinnita'
                },
                accept: refuseOrders
            });
        },

        async markOrdersShipped(selectedOrders) {
            const markOrdersShipped = async () => {
                try {
                    const promises = selectedOrders.map(element => 
                        fetch(this.$fetchIp + '/v2/deal/mark/shipped/' + element.idDeal, {
                            method: 'PATCH',
                            headers: {
                                'Content-type': 'application/json',
                                'Authorization': 'salaTokken'
                            },
                            credentials: 'include',
                        })
                        .then(res => res.json())
                    );

                    const results = await Promise.all(promises);

                    const allSuccessful = results.every(res => res.status === 'success');

                    if (allSuccessful) {
                        this.getShopDeals('inProcess')
                        this.$toast.add({ severity: 'success', summary: 'Saadetud', detail: `${selectedOrders.length} tellimust märgitud saadetuks`, life: 5000 });
                        this.$refs.ordersTableRef.selectedOrders = []
                    } else {
                        console.error('Some deals were not marked as sent successfully.');
                    }
                } catch (error) {
                    console.error('An error occurred while marking deals:', error);
                }
            };

            this.$confirm.require({
                message: `Oled kindel, et soovid ${selectedOrders.length} märkida saadetuks?`,
                header: 'Kinnitus',
                icon: 'pi pi-exclamation-triangle',
                rejectProps: {
                    label: 'Tühista',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Kinnita'
                },
                accept: markOrdersShipped
            });
        },
        
        async finalizeDeals(selectedOrders) {
            const finalizeDeals = async () => {
                try {
                    const promises = selectedOrders.map(element => 
                        fetch(this.$fetchIp + '/v2/deal/self-finalize/' + element.idDeal, {
                            method: 'PATCH',
                            headers: {
                                'Content-type': 'application/json',
                                'Authorization': 'salaTokken'
                            },
                            credentials: 'include',
                        })
                        .then(res => res.json())
                    );

                    const results = await Promise.all(promises);

                    const allSuccessful = results.every(res => res.status === 'success');

                    if (allSuccessful) {
                        this.getShopDeals('inTransit')
                        this.$toast.add({ severity: 'success', summary: 'Lõpetatud', detail: `${selectedOrders.length} tellimust edukalt lõpetatud`, life: 5000 });
                        this.$refs.ordersTableRef.selectedOrders = []
                    } else {
                        console.error('Some deals were not marked as sent successfully.');
                    }
                } catch (error) {
                    console.error('An error occurred while marking deals:', error);
                }
            };

            this.$confirm.require({
                message: `Oled kindel, et soovid ${selectedOrders.length} tellimust lõpetada?`,
                header: 'Kinnitus',
                icon: 'pi pi-exclamation-triangle',
                rejectProps: {
                    label: 'Tühista',
                    severity: 'secondary',
                    outlined: true
                },
                acceptProps: {
                    label: 'Kinnita'
                },
                accept: finalizeDeals
            });
        }
    },
    created() {
        this.statusData =  statusDataJS('isNotAccepted', 'seller')
        this.activeStatus = 'isNotAccepted'
        this.getShopDeals('inProcess')
        this.getShopTransactions()
      // Lifecycle hook - called after the instance is created

    },
    mounted() {
      // Lifecycle hook - called after the component is mounted to the DOM
    
    },
    updated() {
      // Lifecycle hook - called after a data change causes the DOM to re-render
    
    },
  };
</script>
  
<style scoped>
.wrapper {
    background: rgb(238, 242, 245);
    height: 100%;
    min-height: 100vh;
    margin: 0;
    padding-bottom: 50px;
}
.menuWrapper {
    display: fixed;
}
.mainBody {
    position: relative;
    width: 1420px;
    margin: 0 auto;
    padding-top: 130px;
}
.singleTab {
    display: flex;
    flex-wrap: wrap;
    row-gap: 30px;
    column-gap: 40px;
}
@media (max-width: 1470px) {
    .mainBody {
        width: 100%;
        padding-left: 0px;
        padding-right: 0px;
    }
}
@media (max-width: 500px) {
    .menuWrapper {
        padding-top: 67px;
    }
}
@media (max-width: 375px) {
    .mainBody {
        width: 100%;
        padding-left: 0px;
        padding-right: 0px;
    }
}
</style>